import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import { waitingJob } from "@/util/job.utils";
import Loader from "@/components/loader/Loader.vue";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
let AIRoleSelector = class AIRoleSelector extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aiFiles", void 0);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "errorState", false);
    _defineProperty(this, "detectedRoles", []);
    _defineProperty(this, "customRoles", []);
    _defineProperty(this, "selectedRoleIds", []);
    _defineProperty(this, "customRoleInput", "");
    _defineProperty(this, "customCounter", 0);
  }
  get continueButtonLabel() {
    const n = this.selectedRoleIds.length;
    if (n <= 1) {
      return this.$t('aiSpeachGenerator.roleBased.roleSelector.continueButtonOne', {
        n
      });
    }
    return this.$t('aiSpeachGenerator.roleBased.roleSelector.continueButtonMany', {
      n
    });
  }
  mounted() {
    this.analyze();
  }
  analyze() {
    this.loading = true;
    this.errorState = false;
    const formData = new FormData();
    this.aiFiles.forEach(f => formData.append('jobIDs', f.jobID));
    formData.append('language', this.language);
    axios.post('/recorder/aiSpeachGenerator/detectRoles', formData).then(async resp => {
      await this.handleJobResponse(resp.data);
    }).catch(e => {
      console.error(e);
      this.errorState = true;
      this.loading = false;
    });
  }
  async handleJobResponse(jobID) {
    try {
      const data = await waitingJob(jobID);
      const result = data;
      this.detectedRoles = result.roles || [];
      this.loading = false;
    } catch (e) {
      console.error(e);
      this.errorState = true;
      this.loading = false;
    }
  }
  isSelected(roleId) {
    return this.selectedRoleIds.includes(roleId);
  }
  toggleRole(role) {
    const idx = this.selectedRoleIds.indexOf(role.id);
    if (idx === -1) {
      this.selectedRoleIds = [...this.selectedRoleIds, role.id];
    } else {
      this.selectedRoleIds = this.selectedRoleIds.filter(id => id !== role.id);
    }
  }
  addCustomRole() {
    const title = this.customRoleInput.trim();
    if (!title) return;
    // de-duplicate by title (case-insensitive)
    const lowerTitle = title.toLowerCase();
    const alreadyExists = this.detectedRoles.some(r => r.title.toLowerCase() === lowerTitle) || this.customRoles.some(r => r.title.toLowerCase() === lowerTitle);
    if (alreadyExists) {
      this.customRoleInput = "";
      return;
    }
    this.customCounter++;
    const newRole = {
      id: `custom-${this.customCounter}-${lowerTitle.replace(/\s+/g, '-').slice(0, 40)}`,
      title,
      description: '',
      isCustom: true
    };
    this.customRoles = [...this.customRoles, newRole];
    this.selectedRoleIds = [...this.selectedRoleIds, newRole.id];
    this.customRoleInput = "";
  }
  removeCustomRole(roleId) {
    this.customRoles = this.customRoles.filter(r => r.id !== roleId);
    this.selectedRoleIds = this.selectedRoleIds.filter(id => id !== roleId);
  }
  onValidate() {
    if (this.selectedRoleIds.length === 0) return;
    const allRoles = [...this.detectedRoles, ...this.customRoles];
    const selected = allRoles.filter(r => this.selectedRoleIds.includes(r.id));
    this.$emit('rolesSelected', selected);
  }
  onBack() {
    this.$emit('back');
  }
};
__decorate([Prop({
  required: true
})], AIRoleSelector.prototype, "aiFiles", void 0);
__decorate([Prop({
  default: ""
})], AIRoleSelector.prototype, "language", void 0);
AIRoleSelector = __decorate([Component({
  components: {
    Loader,
    Icon,
    StandardButton
  }
})], AIRoleSelector);
export default AIRoleSelector;